import { GeographyTypesEnum } from '../enum/geography-types.enum';
import { GetChildRegionModel } from './get-child-region.param';

export class JournodexGetChildRegionModel extends GetChildRegionModel {
    constructor(
        geographyType?: GeographyTypesEnum,
        parentType?: GeographyTypesEnum,
        parentId?: number
    ) {
        super();
        this.geographyType = geographyType;

        if (parentType) {
            this.parentType = parentType;
            this.parentId = parentId;
        }
    }
}
